import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.ReactNode}
 */
const IconVehiclesTentComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest} fontSize="large" viewBox="0 0 512 512">
      <svg
        className="lucide lucide-tent"
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3.5 21 14 3" fill="none" />
        <path d="M20.5 21 10 3" fill="none" />
        <path d="M15.5 21 12 15l-3.5 6" fill="none" />
        <path d="M2 21h20" fill="none" />
      </svg>
    </SvgIcon>
  );
};

IconVehiclesTentComponent.displayName = 'IconVehiclesTent';

const IconVehiclesTent = React.memo(IconVehiclesTentComponent);

export default IconVehiclesTent;
